"use client";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import ProgressLoader from "../../Atoms/ProgressLoader";

export default function FullScreenOverlay() {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    if (!mounted) return null;

    return createPortal(
        <ProgressLoader />,
        document.body // 👈 this makes it global!
    );
}
